import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-batch-del-receive-line',
  templateUrl: './batch-del-receive-line.component.html',
  styleUrls: ['./batch-del-receive-line.component.css']
})
export class BatchDelReceiveLineComponent implements OnInit {
    batchDelReceiveLineKeyno;

    public info?: Info;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.batchDelReceiveLineKeyno = this.stateService.getStateParams()['batchdelreceiveline_keyno'];
    }

    private async loadInfo() {
        if (!!this.batchDelReceiveLineKeyno) {
            this.info = (await this.datatask.Post(1596, { batchdelreceiveline_keyno: this.batchDelReceiveLineKeyno }))[0];
        }
    }

    public async deleteValues() {
        if (!!this.info) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(1597, this.info))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadInfo();
    }

    ngOnInit() {
        this.init();
    }
}

interface Info {
    batchdelreceiveline_keyno: string;
    batchdelivery_keyno: string;
    reg_by_portal_user_name: string;
    reg_datetime: string;
    purchline_keyno: string;
    colli_quantity: string;
    quantity: string;
    barcode_scanned: string;
    stock_quantity_pr_colli: string;
    prod_id: string;
    prodsize_keyno: string;
    prodchoice_keyno: string;
    show_deletebutton: string;
    prod_name: string;
    url_picture: string;
    stocklocation_keyno: string;
    stocklocation_description: string;
    nbr_of_deviations: string;
    statusinfo: string;
    best_before_date: string;
    suppliers_batchno: string;
}
